// frontend/src/components/charts/ChartSkeleton.tsx
import { Paper, Skeleton, Stack, Group, Text } from '@mantine/core';

interface ChartSkeletonProps {
  title: string;
  height?: number;
}

/**
 * Skeleton placeholder for chart components during loading.
 * Shows the chart title and an animated placeholder for the chart area.
 */
export function ChartSkeleton({ title, height = 400 }: ChartSkeletonProps): JSX.Element {
  return (
    <Paper p="md" withBorder>
      <Stack gap="md">
        {/* Chart title - show actual title so user knows what's loading */}
        <Text size="lg" fw={700}>{title}</Text>

        {/* Chart area with Y-axis label placeholder */}
        <Group align="flex-start" gap="md" wrap="nowrap">
          {/* Y-axis placeholder */}
          <Stack gap="xl" style={{ width: 40 }}>
            <Skeleton height={12} width={30} radius="sm" />
            <Skeleton height={12} width={30} radius="sm" />
            <Skeleton height={12} width={30} radius="sm" />
            <Skeleton height={12} width={30} radius="sm" />
          </Stack>

          {/* Main chart area */}
          <Skeleton
            height={height - 80}
            radius="sm"
            style={{ flex: 1 }}
          />
        </Group>

        {/* X-axis labels placeholder */}
        <Group justify="space-between" px="xl">
          <Skeleton height={12} width={60} radius="sm" />
          <Skeleton height={12} width={60} radius="sm" />
          <Skeleton height={12} width={60} radius="sm" />
          <Skeleton height={12} width={60} radius="sm" />
        </Group>

        {/* Legend placeholder */}
        <Group justify="center" gap="lg">
          <Group gap="xs">
            <Skeleton height={12} width={12} radius="xl" />
            <Skeleton height={12} width={80} radius="sm" />
          </Group>
        </Group>
      </Stack>
    </Paper>
  );
}
